import { keyframes } from '@emotion/react'
import styled from '@emotion/styled'

import { COLORS } from '@/styles/colors'

/** 백드롭 페이드인 — 시트 등장과 함께 어두워짐 */
const backdropFadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`

/** 시트 슬라이드업 — 아래에서 부드럽게 올라옴 */
const sheetSlideUp = keyframes`
  from { transform: translateY(100%); }
  to { transform: translateY(0); }
`

export const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 100;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  animation: ${backdropFadeIn} 240ms ease-out;
`

export const Sheet = styled.div`
  width: 100%;
  max-width: 480px;
  background-color: ${COLORS.bgWhite};
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  display: flex;
  flex-direction: column;
  max-height: 90dvh;
  /* iOS 시트 느낌의 감속 곡선 — 툭 튀지 않고 부드럽게 안착 */
  animation: ${sheetSlideUp} 360ms cubic-bezier(0.32, 0.72, 0, 1);
  will-change: transform;
`

export const SheetHeader = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  height: 64px;
  padding: 16px 8px 12px 24px;
`

export const SheetTitle = styled.h2`
  margin: 0;
  flex: 1;
  font-family: 'Pretendard Variable', 'Pretendard', sans-serif;
  font-size: 20px;
  font-weight: 700;
  line-height: 30px;
  letter-spacing: -0.3px;
  color: ${COLORS.textPrimary};
`

export const CloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  padding: 0;
  border: 0;
  border-radius: 9999px;
  background: transparent;
  color: ${COLORS.textMuted};
  cursor: pointer;
`

export const SheetBody = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 12px 24px 24px;
`

export const SheetFooter = styled.div`
  padding: 12px 24px calc(8px + var(--safe-bottom, 0px));
  background-color: ${COLORS.bgWhite};
`
